<template>
  <div class="report">
    <div class="page-header-wrapper">
      <PageHeader :title="`${roleNameTitle} Activity`"></PageHeader>
      <el-form class="filter-wrapper" label-width="60px" :model="form">
        <el-col :span="6" v-role="[1]">
          <el-form-item label="Role" prop="role">
            <el-select v-model="form.role" placeholder="Please select Role" filterable @change="roleChange">
              <el-option v-for="(item, idx) in roleOptions" :key="idx" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-role="[1]">
          <el-form-item label="Leader" prop="taId">
            <el-select v-model="form.taId" placeholder="Please select Leader" filterable @change="taChange">
              <el-option v-for="(item, idx) in taOptions" :key="idx" :label="item.TAName" :value="item.TAID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Team" prop="teamId">
            <el-select v-model="form.teamId" placeholder="Please select Team" filterable>
              <el-option v-for="(item, idx) in teamOptions" :key="idx" :label="item.TeamName" :value="item.TeamID">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Year" prop="year">
            <el-select v-model="form.year" placeholder="Please select year">
              <el-option v-for="item in yearsOptions" :key="item.Year" :label="item.Year" :value="item.Year">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Month" prop="month">
            <el-select class="month-select" ref="monthSelect" v-model="form.month" placeholder="Please select month"
              multiple v-multiple-tip @change="monthSelectChange">
              <el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Type" prop="type">
            <el-select v-model="form.type" placeholder="Please select type">
              <el-option label="All" value="" />
              <el-option label="Content Push / Meeting Push" value="ContentMeetingPush" />
              <el-option label="Quick Push" value="QuickPush" />
            </el-select>
          </el-form-item>
        </el-col>
        <div class="query-action">
          <el-button type="primary" icon="el-icon-search" @click="getTableData()" :disabled="queryable">
            Query
          </el-button>
          <el-button type="primary" icon="iconfont icon-export" @click="getTableData(true)" :disabled="exportable"
            :loading="exporting">
            Export
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="charts" ref="charts" v-role="[1, 2, 4, 6, 8, 10, 12]">
      <div class="chart-row">
        <div class="chart-wrapper">
          <h4>No. Of {{ nameLabel }}</h4>
          <div v-show="!noOfSEDataEmpty" class="chart" ref="noOfSE"></div>
          <div v-show="noOfSEDataEmpty" class="chart empty">
            <span>No Data</span>
          </div>
        </div>
        <div class="chart-wrapper">
          <h4>No. Of Pushed Content / Push / {{ nameLabel }} Has Been Pushed</h4>
          <div v-show="!linesDataEmpty" class="chart" ref="linesChart"></div>
          <div v-show="linesDataEmpty" class="chart empty">
            <span>No Data</span>
          </div>
        </div>
      </div>
      <div class="chart-row">
        <div class="chart-wrapper">
          <h4>Avg Push/{{ nameLabel }}</h4>
          <div v-show="!avgPushSEDataEmpty" class="chart" ref="avgPushSE"></div>
          <div v-show="avgPushSEDataEmpty" class="chart empty">
            <span>No Data</span>
          </div>
        </div>
        <div class="chart-wrapper">
          <h4>{{ nameLabel }} Coverage</h4>
          <div v-show="!seCoverageDataEmpty" class="chart" ref="seCoverage"></div>
          <div v-show="seCoverageDataEmpty" class="chart empty">
            <span>No Data</span>
          </div>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table :data="tableData" v-loading="tableLoading" element-loading-text="Loading...">
        <el-table-column prop="MLName" :label="roleNameTitle" min-width="130" />
        <el-table-column prop="TaConfigName" label="TA" min-width="130" />
        <el-table-column prop="NoOfSE" :label="`No. Of ${nameLabel}`" min-width="140" />
        <el-table-column prop="NoOfPush" label="No. Of Push" min-width="120" />
        <el-table-column prop="AvgPushPerSE" :label="`Avg Push/${nameLabel}`" min-width="160" />
        <el-table-column min-width="190" prop="NoOfPushedContent" label="No. Of Pushed Content" />

        <el-table-column :label="`No. Of ${nameLabel} Has Been Pushed`" min-width="260" prop="NoOfSEBeenPushed" />
        <el-table-column min-width="160" prop="SECoverage" :label="`${nameLabel} Coverage`" />
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";
import * as echarts from "echarts/core";
import { PieChart, BarChart, LineChart, ScatterChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent,
} from "echarts/components";
import { SVGRenderer } from "echarts/renderers";
echarts.use([
  GridComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent,
  PieChart,
  BarChart,
  LineChart,
  ScatterChart,
  SVGRenderer,
]);
import moment from "moment";
import downloadjs from "downloadjs";
import { getDataZoomOptions } from "../../utils/echarts";
import { parseSubRoleName, RoleCode } from "@/utils/role-constant";

export default {
  name: "User-Activity",
  data() {
    return {
      tableData: [],
      tableLoading: false,
      exporting: false,
      form: {
        role: "",
        taId: "",
        teamId: "",
        year: moment().year(),
        month: [moment().month() + 1],
        type: ""
      },
      otherList: null,
      roleList: [],
      taList: [],
      teamList: [],
      monthOptions: [
        {
          label: "All",
          value: "",
        },
      ],
      // charts as follow:
      loadingOption: {
        text: "loading...",
        color: "#d52b1e",
        lineWidth: 2,
      },
      noOfSEChart: null,
      noOfSEData: null,
      noOfSEDataEmpty: false,
      avgPushSEChart: null,
      avgPushSEData: null,
      avgPushSEDataEmpty: false,
      seCoverageChart: null,
      seCoverageData: null,
      seCoverageDataEmpty: false,
      linesChart: null,
      linesData: null,
      linesDataEmpty: false,
      queryable: true,
      exportable: true,
      resizeListener: null,
    };
  },
  created() {
    this.getData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getData();
      }
    });
    this.bus.$on("onSideMenuCollapse", () => {
      if (this.$options.name === this.$route.meta.title) {
        echarts.throttle(() => {
          this.renderCharts(true);
        }, 200);
      }
    });
    for (let i = 1; i <= 12; i++) {
      this.monthOptions.push({
        label: i,
        value: i,
      });
    }
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    filterSpan() {
      return this.role === 1 ? 6 : 5;
    },
    teamName() {
      let team = this.teamList.find((item) => item.TeamID === this.form.teamId);
      return team ? team.TeamName : "";
    },
    isShowCharts() {
      return this.role === RoleCode.Admin ||
        this.role === RoleCode.Supervisor ||
        this.role === RoleCode.TALead ||
        this.role === RoleCode.CRPLeader ||
        this.role === RoleCode.CVEOLeader ||
        this.role === RoleCode.SciComLeader ||
        this.role === RoleCode.ClinTransLeader;
    },
    roleOptions() {
      return [{ value: "", name: "All" }].concat(this.roleList);
    },
    taOptions() {
      return [{ TAName: "All", TAID: "", RoleName: "" }].concat(
        this.taList.filter(({ RoleName }) => {
          return this.form.role ? this.form.role === "MSL" ? RoleName === "TALead" : RoleName.indexOf(this.form.role) > -1 : true;
        })
      );
    },
    yearsOptions() {
      return this.otherList ? this.otherList.year : [];
    },
    teamOptions() {
      let options = this.teamList.filter(({ TAID, RoleName }) => {
        return this.form.taId ? this.form.taId === TAID
          : (RoleName.indexOf(this.form.role) > -1 || (this.form.role === "MSL" && (RoleName === "TALead" || RoleName === "Supervisor")))
      });
      return this.role === 1 || this.role === 4 ? [{ TeamName: "All", TeamID: "", RoleName: "" }].concat(options) : options;
    },
    barWidth() {
      return document.body.clientHeight / 35;
    },
    roleNameTitle() {
      let roleName = parseSubRoleName(this.role);
      roleName = roleName === null ? "MSL" : roleName;
      return roleName;
    },
    nameLabel() {
      return this.role === RoleCode.Admin || this.role === RoleCode.Supervisor || this.role === RoleCode.TALead ? "HCP" : "Customer";
    },
  },
  mounted() {
    if (this.isShowCharts) {
      this.renderCharts();
      this.resizeListener = echarts.throttle(() => {
        if (this.$options.name === this.$route.meta.title) {
          this.onResize();
          this.$nextTick(() => {
            this.renderCharts(true);
          });
        }
      }, 100);
      addResizeListener(this.$refs.charts, this.resizeListener);
    }
  },
  beforeDestroy() {
    if (this.isShowCharts && this.resizeListener) {
      removeResizeListener(this.$refs.charts, this.resizeListener);
    }
  },
  activated() {
    this.onResize();
    this.$nextTick(() => {
      this.renderCharts(true);
    });
  },
  methods: {
    getDataZoomOptions,
    roleChange() {
      this.form.taId = "";
      this.form.teamId = "";
    },
    taChange() {
      this.form.teamId = "";
    },
    monthSelectChange(value) {
      const filter = (val) => val === "";
      const index = value.findIndex(filter);
      const isAll = value.some(filter);
      this.form.month = value.filter((val) => {
        return isAll && (index !== 0 || value.length === 1)
          ? val === ""
          : val !== "";
      });
      if (value.length === 0) {
        this.form.month = [""];
      }
    },
    onResize() {
      if (this.$route.meta.title === this.$options.name) {
        this.noOfSEChart && this.noOfSEChart.resize();
        this.avgPushSEChart && this.avgPushSEChart.resize();
        this.seCoverageChart && this.seCoverageChart.resize();
        this.linesChart && this.linesChart.resize();
      }
    },
    renderCharts(hideLoading = false) {
      this.renderNoOfSEChart();
      this.renderAvgPushSEChart();
      this.renderSeCoverageChart();
      this.renderLinesChart();
      if (hideLoading) {
        this.hideLoadings();
      }
    },
    hideLoadings() {
      this.noOfSEChart && this.noOfSEChart.hideLoading();
      this.avgPushSEChart && this.avgPushSEChart.hideLoading();
      this.seCoverageChart && this.seCoverageChart.hideLoading();
      this.linesChart && this.linesChart.hideLoading();
    },
    showLoadings() {
      this.noOfSEChart && this.noOfSEChart.showLoading(this.loadingOption);
      this.avgPushSEChart &&
        this.avgPushSEChart.showLoading(this.loadingOption);
      this.seCoverageChart &&
        this.seCoverageChart.showLoading(this.loadingOption);
      this.linesChart && this.linesChart.showLoading(this.loadingOption);
    },
    getTableData(exportable = false) {
      this.tableLoading = !exportable;
      this.exporting = exportable;
      if (this.isShowCharts && !exportable) {
        this.noOfSEDataEmpty = false;
        this.linesDataEmpty = false;
        this.avgPushSEDataEmpty = false;
        this.seCoverageDataEmpty = false;
        this.$nextTick(() => {
          this.onResize();
        });
        this.showLoadings();
      }
      const month = this.form.month.filter((value) => value !== "");
      let params = {
        ...this.form,
        month: month.toString(),
        exportable: exportable ? 1 : 0,
      };
      if (exportable) {
        Object.assign(params, {
          teamName: this.teamName,
        });
      }
      this.axios
        .get("analytics/mlActivity", {
          params: params,
          responseType: exportable ? "blob" : "json",
        })
        .then(({ code, data, msg }) => {
          if (exportable) {
            downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
            this.exporting = false;
          } else {
            if (200 === code) {
              this.tableLoading = false;
              if (this.isShowCharts) {
                const {
                  SENo,
                  AvgPushSE,
                  CoverageSE,
                  PushNo,
                  ContentNo,
                  PushedSENo,
                } = data;
                this.noOfSEData = SENo;
                this.avgPushSEData = AvgPushSE;
                this.seCoverageData = CoverageSE;
                this.linesData = {
                  pushedContent: ContentNo,
                  push: PushNo,
                  seHasBeenPush: PushedSENo,
                };
                this.renderCharts(true);
              }

              this.tableData = data.tableData;
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          this.exporting = false;
        });
    },
    getData() {
      Promise.all([
        this.axios.get(`analytics/roleList`),
        this.axios.get(`analytics/otherList`),
        this.axios.get(`analytics/taList`),
        this.axios.get("analytics/teamList"),
      ]).then((res) => {
        this.getRoleList(res[0]);
        this.getOtherList(res[1]);
        this.getTAList(res[2]);
        this.getTeamList(res[3]);
        this.queryable = false;
        this.exportable = false;
        this.getTableData();
      });
    },
    getRoleList({ code, data, msg }) {
      if (200 === code) {
        this.roleList = data;
        if (this.role === RoleCode.Supervisor || this.role === RoleCode.TALead) {
          const { value } = data[0] || { value: "" };
          this.form.role = value;
        } else {
          const roleName = this.$store.state.userInfo.roleName;
          const { value } = this.roleList.find(({ value }) => roleName.indexOf(value) > -1) || { value: "" };
          this.form.role = value;
        }
      } else {
        this.$message.error(msg);
      }
    },
    getOtherList({ code, data, msg }) {
      if (200 === code) {
        this.otherList = data;
      } else {
        this.$message.error(msg);
      }
    },
    getTAList({ code, data, msg }) {
      if (200 === code) {
        if (this.role === RoleCode.TALead) {
          this.form.taId = data.length > 0 ? data[0].TAID : "";
        } else {
          this.taList = data;
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTeamList({ code, data, msg }) {
      if (200 === code) {
        this.teamList = data;
        if (this.role == RoleCode.Supervisor
          || this.role == RoleCode.CRPLeader
          || this.role == RoleCode.CVEOLeader
          || this.role == RoleCode.SciComLeader
          || this.role == RoleCode.ClinTransLeader) {
          this.form.teamId = data.length > 0 ? data[0].TeamID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    renderNoOfSEChart() {
      let outerData = {
        name: "",
        data: [],
      };
      let innerData = {
        name: "",
        data: [],
      };
      if (this.noOfSEData) {
        outerData = this.noOfSEData.outData;
        innerData = this.noOfSEData.inData;
        this.noOfSEDataEmpty = outerData.data.length === 0;
      }
      let series = [];
      let out = {
        name: outerData.name,
        type: "pie",
        center: ["50%", "43%"],
        radius: ["45%", "60%"],
        labelLine: {
          length: 30,
        },
        data: outerData.data,
      };
      if (this.role === 2) {
        series = [out];
      } else {
        series = [
          {
            name: innerData.name,
            type: "pie",
            selectedMode: "single",
            center: ["50%", "43%"],
            radius: [0, "30%"],
            label: {
              position: "inner",
              fontSize: 11,
            },
            labelLine: {
              show: false,
            },
            data: innerData.data,
          },
          out,
        ];
      }
      let option = {
        tooltip: {
          trigger: "item",
          padding: 6,
          confine: true,
          borderWidth: 0,
          className: "echart-tooltip",
          formatter: (params) => {
            return `<h4>${params.name}</h4><div class="chart-tooltip"><i style="background: ${params.color};"></i><span>No. Of ${this.nameLabel}</span><strong>${params.value}</strong></div>`;
          },
        },
        grid: {
          top: 30,
          bottom: 10,
          containLabel: true,
        },
        series: series,
      };
      if (!this.noOfSEChart) {
        this.noOfSEChart = echarts.init(this.$refs.noOfSE, null, {
          renderer: "svg",
        });
        this.noOfSEChart.showLoading(this.loadingOption);
      }
      this.noOfSEChart.setOption(option);
    },
    renderAvgPushSEChart() {
      let chart = this.$refs.avgPushSE;
      let width = chart ? chart.offsetWidth : 0;
      let xAxisData = [];
      let valueData = [];
      if (this.avgPushSEData) {
        this.avgPushSEData.data.forEach((i) => {
          xAxisData.push(i.name);
          valueData.push(i.value);
        });
        this.avgPushSEDataEmpty = this.avgPushSEData.data.length === 0;
      }
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          padding: 6,
          confine: true,
          className: "echart-tooltip",
          formatter: ([params]) => {
            return `<h4>${params.name
              }</h4><div class="chart-tooltip"><i style="background:${params.color
              }"></i><span>Avg Push/${this.nameLabel}</span><strong>${new Number(
                params.data
              ).toFixed(2)}</strong></div>`;
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: 30,
          bottom: 30,
          containLabel: true,
        },
        dataZoom:
          xAxisData.length > 10
            ? this.getDataZoomOptions(
              0,
              document.body.clientWidth <= 1024 ? 30 : 40
            )
            : null,
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            lineHeight: 16,
            fontSize: 11,
            width: width / 7,
            overflow: "truncate",
            formatter: (value, index) => {
              return `${index % 2 !== 0 && xAxisData.length >= 5 ? "\n" : ""
                }${value}`;
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
          },
        },
        barWidth: this.barWidth,
        series: [
          {
            data: valueData,
            type: "bar",
            label: {
              show: true,
              position: "top",
              formatter(value) {
                return value.data.toFixed(2);
              },
            },
            itemStyle: {
              color: "#ee6666",
            },
          },
        ],
      };
      if (!this.avgPushSEChart) {
        this.avgPushSEChart = echarts.init(this.$refs.avgPushSE, null, {
          renderer: "svg",
        });
        this.avgPushSEChart.showLoading(this.loadingOption);
      }
      this.avgPushSEChart.setOption(option);
    },
    renderSeCoverageChart() {
      let chart = this.$refs.seCoverage;
      let width = chart ? chart.offsetWidth : 0;
      let xAxisData = [];
      let valueData = [];
      if (this.seCoverageData) {
        this.seCoverageData.data.forEach((i) => {
          xAxisData.push(i.name);
          valueData.push((i.value * 100).toFixed(2));
        });
        this.seCoverageDataEmpty = this.seCoverageData.data.length === 0;
      }
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          padding: 6,
          confine: true,
          className: "echart-tooltip",
          formatter: ([params]) => {
            return `<h4>${params.name
              }</h4><div class="chart-tooltip"><i style="background:${params.color
              }"></i><span>${this.nameLabel} Coverage</span><strong>${new Number(
                params.data
              ).toFixed(2)}%</strong></div>`;
          },
        },
        grid: {
          left: "5%",
          right: "5%",
          top: 30,
          bottom: 30,
          containLabel: true,
        },
        dataZoom:
          xAxisData.length > 10
            ? this.getDataZoomOptions(
              0,
              document.body.clientWidth <= 1024 ? 30 : 40
            )
            : null,
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            lineHeight: 16,
            fontSize: 11,
            width: width / 7,
            overflow: "truncate",
            formatter: (value, index) => {
              return `${index % 2 !== 0 && xAxisData.length >= 5 ? "\n" : ""
                }${value}`;
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
          },
          axisLabel: {
            formatter: function (value) {
              return `${value}%`;
            },
          },
        },
        barWidth: this.barWidth,
        series: [
          {
            data: valueData,
            type: "bar",
            label: {
              show: true,
              position: "top",
              formatter(value) {
                return `${new Number(value.data).toFixed(2)}%`;
              },
            },
            itemStyle: {
              color: "#3ba272",
            },
          },
        ],
      };
      if (!this.seCoverageChart) {
        this.seCoverageChart = echarts.init(this.$refs.seCoverage, null, {
          renderer: "svg",
        });
        this.seCoverageChart.showLoading(this.loadingOption);
      }
      this.seCoverageChart.setOption(option);
    },
    renderLinesChart() {
      let chart = this.$refs.linesChart;
      let width = chart ? chart.offsetWidth : 0;
      let xAxisData = this.linesData
        ? Array.from(this.linesData.push.data, (x) => x.name)
        : [];
      let pushedContentData = this.linesData
        ? Array.from(this.linesData.pushedContent.data, (x) => [
          x.name,
          x.value,
        ])
        : [];
      let pushData = this.linesData
        ? Array.from(this.linesData.push.data, (x) => [x.name, x.value])
        : [];
      let seHasBeenPushData = this.linesData
        ? Array.from(this.linesData.seHasBeenPush.data, (x) => [
          x.name,
          x.value,
        ])
        : [];
      if (this.linesData) {
        this.linesDataEmpty = xAxisData.length === 0;
      }
      const itemStyle = {
        opacity: 0.8,
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: "rgba(0,0,0,0.1)",
      };
      let option = {
        tooltip: {
          trigger: "axis",
          padding: 6,
          confine: true,
          className: "echart-tooltip",
          formatter(params) {
            let htmlDom =
              params[0].name != " " ? `<h4>${params[0].name}</h4>` : "";
            let isEmpty = false;
            params.forEach((item) => {
              isEmpty = item.value === "";
              if (!isEmpty) {
                htmlDom += `<div class="chart-tooltip"><i style="background:${item.color}"></i><span>${item.seriesName}</span><strong>${item.value[1]}</strong></div>`;
              }
            });
            return htmlDom;
          },
        },
        legend: {
          top: 5,
          data: [
            "No. Of Pushed Content",
            "No. Of Push",
            `No. Of ${this.nameLabel} Has Been Pushed`,
          ],
        },
        grid: {
          left: "5%",
          right: "8%",
          top: "20%",
          bottom: 30,
          containLabel: true,
        },
        dataZoom:
          xAxisData.length > 10
            ? this.getDataZoomOptions(
              0,
              document.body.clientWidth <= 1024 ? 30 : 40
            )
            : null,
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLabel: {
            interval: 0,
            lineHeight: 16,
            fontSize: 11,
            width: width / 7,
            overflow: "truncate",
            formatter: (value, index) => {
              return `${(index + 1) % 2 !== 0 && xAxisData.length >= 5 ? "\n" : ""
                }${value}`;
            },
          },
          axisTick: {
            alignWithLabel: true,
          },
          min: -1,
          max: xAxisData.length,
          boundaryGap: false,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "No. Of Pushed Content",
            type: "scatter",
            itemStyle: itemStyle,
            data: pushedContentData,
          },
          {
            name: "No. Of Push",
            type: "scatter",
            itemStyle: itemStyle,
            data: pushData,
          },
          {
            name: `No. Of ${this.nameLabel} Has Been Pushed`,
            type: "scatter",
            itemStyle: itemStyle,
            data: seHasBeenPushData,
          },
        ],
      };
      if (!this.linesChart) {
        this.linesChart = echarts.init(this.$refs.linesChart, null, {
          renderer: "svg",
        });
        this.linesChart.showLoading(this.loadingOption);
      }
      this.linesChart.setOption(option);
    },
  },
};
</script>
<style scoped lang="scss">
.filter-wrapper {
  padding-top: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: inherit !important;
  flex-wrap: wrap;
  padding: 0 !important;

  .el-form-item {
    margin-bottom: 10px !important;

    .el-select {
      width: 100%;
    }
  }

  .query-action {
    flex: 1;
    margin-bottom: 10px;
    margin-left: 10px;
    white-space: nowrap;
    text-align: right;
  }
}
</style>